<template>
  <div id="_tlqn_admin_quality" class="q-pa-md">
    <q-table
      class="rounded-borders sticky-header-table fit"
      :data="tableData"
      :columns="columnDef"
      :loading="loadingSubmitedSampleList"
      row-key="index"
      virtual-scroll
      :pagination.sync="pagination"
      :rows-per-page-options="[0]"
      separator="horizontal"
      hide-bottom
    >
      <template v-slot:top>
        <div class="full-width row justify-between">
          <div style="font-size: 1.2rem; font-weight: bold">
            {{
              tabs.find((item) => {
                return item.name === tab;
              }).label
            }}
            <span style="font-size: 0.8rem" class="text-grey-8">
              （右侧切换质控功能模块）
            </span>
            <span class="text-caption">
              共
              <span class="text-primary">{{ tableData.length }}</span>
              条记录
            </span>
          </div>

          <div class="row items-center">
            <q-input
              filled
              class="q-mr-md"
              v-model="searchKeyword"
              style="width: 300px"
              label="在此搜索样本名称/样本id/用户昵称/手机号"
              dense
            />
            <q-tabs
              v-model="adminQualityStatusTab"
              dense
              active-color="green"
              class="bg-grey-2 text-grey-8 q-mr-lg rouneded-borders"
              v-if="tab != 'reject'"
            >
              <q-tab
                v-for="status in adminQualityStatus"
                :key="status.index"
                :name="status.name"
                :label="status.name"
              />
            </q-tabs>

            <q-tabs
              v-model="tab"
              dense
              class="bg-grey-3 text-grey-7 rounded-borders"
              active-color="primary"
              indicator-color="primary"
              align="justify"
              narrow-indicator
            >
              <q-tab
                class="rounded-borders"
                v-for="item in tabs"
                :key="item.name"
                :name="item.name"
                :label="item.label"
              />
            </q-tabs>
          </div>
        </div>
      </template>

      <template v-slot:body="props">
        <q-tr :props="props">
          <q-td key="sample_id" :props="props">
            <MatchHighlight
              class-name="tlqn-ad-gmls-search-match"
              :keyword="searchKeyword"
              :text="props.row.detail.sample_id"
            />
          </q-td>

          <q-td key="name" :props="props">
            <MatchHighlight
              class-name="tlqn-ad-gmls-search-match"
              :keyword="searchKeyword"
              :text="props.row.detail.name"
            />
          </q-td>
          <q-td key="submit_at" :props="props">
            {{
              tab === "answer"
                ? props.row.submit_at
                : props.row.timestamp.updatedAt
            }}
          </q-td>
          <q-td key="user" :props="props">
            <span class="text-bold">
              <MatchHighlight
                v-if="props.row.user"
                class-name="tlqn-ad-gmls-search-match"
                :keyword="searchKeyword"
                :text="props.row.user.nickname"
              />
              <span v-else>缺失</span>
            </span>
            <span class="text-grey">
              <span>(</span>
              <MatchHighlight
                v-if="props.row.user"
                class-name="tlqn-ad-gmls-search-match"
                :keyword="searchKeyword"
                :text="props.row.user.phone_number"
              />
              <span v-else>缺失</span>
              <span>)</span>
            </span>
          </q-td>

          <q-td v-if="tab === 'answer'" key="dkrf_rate" :props="props">
            <span
              :class="{
                'text-red': props.row.dkrf_rate && props.row.dkrf_rate > 0.5,
                'text-green': !props.row.dkrf_rate || props.row.dkrf_rate < 0.1,
              }"
            >
              {{ ((props.row.dkrf_rate || 0) * 100).toFixed(1) }}%
            </span>
          </q-td>

          <q-td v-if="tab === 'answer'" key="adminQualityStatus" :props="props">
            <span v-if="props.row.admin_quality" class="text-bold">
              {{ props.row.admin_quality.status }}
            </span>
            <span v-else class="text-bold"> 未开始 </span>
          </q-td>

          <q-td v-if="tab === 'answer'" key="adminQualityUser" :props="props">
            <span v-if="props.row.admin_quality" class="text-bold">
              {{ props.row.admin_quality.user.nickname }}
            </span>
            <span v-else> 未指定 </span>
          </q-td>

          <q-td v-if="tab === 'reject'" key="reject_type" :props="props">
            <span
              :class="{
                'text-red-10': props.row.if_not_find,
                'text-orange-10': !props.row.if_not_find,
                'text-bold': true,
              }"
            >
              {{
                props.row.if_not_find
                  ? "无效样本（找不到）记录"
                  : "拒访样本记录"
              }}
            </span>
          </q-td>

          <q-td key="operation" :props="props">
            <q-btn
              class="q-px-sm"
              dense
              flat
              color="primary"
              @click="
                tab === 'answer'
                  ? loadAnswer(
                      props.row.id,
                      props.row.admin_quality
                        ? props.row.admin_quality.notes
                          ? props.row.admin_quality.notes
                          : ''
                        : ''
                    )
                  : loadReject(props.row)
              "
            >
              <!-- 查看答案 -->
              <q-icon size="1rem" name="fas fa-receipt" />
              <q-tooltip>
                {{ tab === "answer" ? "查看答案" : "查看详情" }}
              </q-tooltip>
            </q-btn>

            <a
              :href="`${downloadPrefix}/voice/dir/${props.row.id}`"
              target="_blank"
              v-if="tab === 'answer'"
            >
              <q-btn class="q-px-sm q-ml-xs" dense flat color="secondary">
                <q-icon name="fas fa-microphone-alt" size="1rem" />
                <q-tooltip> 录音下载 </q-tooltip>
              </q-btn>
            </a>
            <q-btn
              class="q-px-sm"
              dense
              flat
              color="blue-10"
              @click="
                resetSample(
                  tab === 'answer' ? props.row.id : props.row.sample.id
                )
              "
            >
              <!-- 查看答案 -->
              <q-icon size="1rem" name="fas fa-edit" />
              <q-tooltip> 重新分配样本 </q-tooltip>
            </q-btn>
          </q-td>
        </q-tr>
      </template>
    </q-table>
    <q-dialog persistent v-model="showAnswerModal">
      <Answer
        :sampleId="currentAnswerSampleId"
        :oldNotes="currentOldNotes"
        v-on:closeQualityEditor="closeQualityEditor"
      />
    </q-dialog>
    <q-dialog v-model="showRestDialog">
      <rest-sample :sampleId="currentAnswerSampleId" />
    </q-dialog>

    <q-dialog v-if="currentRejectSample" v-model="showRejctedInfo">
      <q-card style="min-width: 55vw" class="q-ma-md">
        <q-card-section class="row items-center bg-primary">
          <q-icon name="fas fa-city" color="white" />
          <span class="q-ml-sm text-subtitle1 text-bold text-white">
            {{ currentRejectSample.detail.name }}</span
          >
        </q-card-section>

        <q-card-section>
          访员<span class="text-bold">
            {{
              currentRejectSample.user
                ? currentRejectSample.user.nickname
                : "缺失"
            }}
          </span>
          记录的信息如下: <br />

          <div class="rounded-borders bg-yellow-2 q-ma-md q-pa-md">
            {{ currentRejectSample.rejected_content }}
          </div>
          <div
            v-if="
              currentRejectSample.rejected_image_url &&
              currentRejectSample.rejected_image_url.length > 0
            "
          >
            <q-img
              v-for="(
                img_url, img_index
              ) in currentRejectSample.rejected_image_url"
              :key="img_index"
              :src="img_url"
              style="max-width: 600px; height: 200px"
              contain
            />
          </div>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="确认" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog :value="!!loadingText">
      <q-card
        style="height: 300px; width: 300px"
        class="column items-center justify-center"
      >
        <Loading :text="loadingText" />
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { fetchSampleListByQuery } from "@/api/endpoints/sample/fetchSampleListByQuery";
import moment from "moment";
import { getAllRejectedSample } from "@/api/endpoints/rejected-sample/getAllRejectedSample";
import { getAllAdminQualityStatus } from "@/api/endpoints/admin-quality/getAllAdminQualityStatus";
import { EventBus } from "@/bus/index";
import { SAMPLE_RESET_LIST_CHANGED } from "@/bus/admin.events";

export default {
  components: {
    Answer: () => import("./Answer"),
    Loading: () => import("@/components/Loading"),
    RestSample: () => import("./RestSample"),
    MatchHighlight: () => import("@/components/MatchHighlight"),
  },
  data() {
    return {
      columnDef: [],
      submitedSampleList: [],
      rejectedSampleList: [],
      loadingSubmitedSampleList: false,
      pagination: {
        rowsPerPage: 0,
      },
      tab: "answer",
      tabs: [
        {
          name: "answer",
          label: "问卷情况",
        },
        {
          name: "reject",
          label: "缺失/无效记录",
        },
      ],
      showAnswerModal: false,
      showRejctedInfo: false,
      showRestDialog: false,
      currentAnswerSampleId: null,
      currentRejectSample: null,
      currentOldNotes: null,
      loadingText: "",
      searchKeyword: "",
      adminQualityStatus: {},
      adminQualityStatusTab: "未开始",
    };
  },

  mounted() {
    // this.loadSubmitedSampleList();
    this.loadAdminQualityStatusList();
    EventBus.$on(SAMPLE_RESET_LIST_CHANGED, this.reflashList);
  },

  beforeDestroy() {
    console.log("destroy");
    EventBus.$off(SAMPLE_RESET_LIST_CHANGED, this.reflashList);
  },
  computed: {
    downloadPrefix() {
      return process.env.VUE_APP_PROXY_API_ALIAS;
    },

    tableData() {
      const {
        tab,
        submitedSampleList,
        rejectedSampleList,
        searchKeyword,
        adminQualityStatusTab,
      } = this;
      // console.log("submitedSampleList", submitedSampleList);
      let data = tab === "answer" ? submitedSampleList : rejectedSampleList;
      data = data.filter((sample) => {
        const matchSampleName =
          sample &&
          sample.detail &&
          sample.detail.name &&
          sample.detail.name.indexOf(searchKeyword) > -1;
        const matchSampleId =
          sample &&
          sample.detail &&
          sample.detail.sample_id &&
          sample.detail.sample_id.indexOf(searchKeyword) > -1;
        const matchUserName =
          sample &&
          sample.user &&
          sample.user.nickname &&
          sample.user.nickname.indexOf(searchKeyword) > -1;
        const matchUserPhone =
          sample &&
          sample.user &&
          sample.user.phone_number &&
          sample.user.phone_number.indexOf(searchKeyword) > -1;
        const matchSearch =
          matchSampleName || matchSampleId || matchUserName || matchUserPhone;
        const matchStatusTab = sample.admin_quality
          ? sample.admin_quality.status === adminQualityStatusTab
          : adminQualityStatusTab === "未开始";
        return matchSearch && (matchStatusTab || tab !== "answer");
      });
      return data;
    },
  },
  watch: {
    tab: {
      immediate: true,
      handler() {
        const sort = (a, b, rowA, rowB) => {
          const _a = new Date(a);
          const _b = new Date(b);
          return _a.getTime() - _b.getTime();
        };
        if (this.tab === "answer") {
          this.loadSubmitedSampleList();
          const sort = (a, b) =>
            (new Date(a).getTime() || 0) - (new Date(b).getTime() || 0);

          this.columnDef = [
            {
              name: "sample_id",
              label: "样本id",
              align: "center",
              style: "width: 120px",
            },
            {
              name: "name",
              label: "样本名称",
              align: "center",
              sortable: true,
            },
            {
              name: "submit_at",
              label: "提交时间",
              align: "center",
              field: "submit_at",
              sortable: true,
              sort,
            },
            {
              name: "user",
              label: "访员信息",
              align: "center",
            },

            {
              name: "dkrf_rate",
              label: "拒答率",
              align: "center",
              field: "dkrf_rate",
              sortable: true,
            },
            {
              name: "adminQualityStatus",
              label: "质控状态",
              align: "center",
            },
            {
              name: "adminQualityUser",
              label: "质控员",
              align: "center",
            },
            {
              name: "operation",
              label: "操作",
              align: "center",
            },
          ];
        }
        if (this.tab === "reject") {
          this.loadRejectedSampleList();
          this.columnDef = [
            {
              name: "sample_id",
              label: "样本id",
              align: "center",
              style: "width: 120px",
            },
            {
              name: "name",
              label: "样本名称",
              align: "center",
              sortable: true,
            },
            {
              name: "submit_at",
              label: "提交时间",
              align: "center",
              field: "submit_at",
              sortable: true,
              sort,
            },
            {
              name: "user",
              label: "访员信息",
              align: "center",
            },

            {
              name: "reject_type",
              label: "无效或拒访类型",
              align: "center",
              field: "reject_type",
              sortable: true,
            },

            {
              name: "operation",
              label: "操作",
              align: "center",
            },
          ];
        }
      },
    },
  },

  methods: {
    /**
     * 加载已完成的样本列表
     */
    async loadSubmitedSampleList() {
      this.loadingSubmitedSampleList = true;
      try {
        const response = await fetchSampleListByQuery(
          { user: true, quality: true },
          ["sample_id", "name"],
          {
            sample_status: 0,
          }
        );
        if (!response || response.status)
          throw Error(response.detail || response.message);
        const list = this.resolveSamples(response);
        try {
          list.sort((s1, s2) => {
            const t1 = s1.submit_at;
            const t2 = s2.submit_at;
            return new Date(t1).getTime() - new Date(t2).getTime();
          });
        } catch (err) {}
        this.submitedSampleList = list;
        // console.log(this.submitedSampleList);
      } catch (err) {
        console.log(err);
      } finally {
        this.loadingSubmitedSampleList = false;
      }
    },

    /**
     * 加载样本答案
     */
    async loadAnswer(sampleId, notes) {
      this.currentAnswerSampleId = sampleId;
      if (notes=== ""){
        this.currentOldNotes = []
      } else {
        this.currentOldNotes = notes;
      }
      this.showAnswerModal = true;
    },

    async loadReject(sample) {
      this.showRejctedInfo = true;
      this.currentRejectSample = sample;
    },

    async loadAdminQualityStatusList() {
      try {
        this.adminQualityStatus = await getAllAdminQualityStatus();
        console.log("status", this.adminQualityStatus);
      } catch (error) {
        console.log(error);
        this.$q.notify({
          type: "danger",
          message: "未知错误：" + error.toString(),
        });
      }
    },

    async resetSample(sampleId) {
      // console.log(sample)
      this.currentAnswerSampleId = sampleId;
      // console.log("current  id", this.currentAnswerSampleId);
      this.showRestDialog = true;
    },

    resolveSamples(samples) {
      const formatRaw = "YYYY-MM-DD hh:mm:ss a";
      samples.forEach((sample) => {
        if (this.tab === "answer") {
          sample.submit_at = moment(sample.submit_at).format(formatRaw);
        }
        if (this.tab === "reject") {
          sample.timestamp.updatedAt = moment(
            sample.timestamp.updatedAt
          ).format(formatRaw);
        }
      });
      return samples;
    },

    async loadRejectedSampleList() {
      console.log("abc");
      this.loadingSubmitedSampleList = true;
      try {
        const response = await getAllRejectedSample();
        if (!response || response.status) {
          this.$q.notify({
            type: "danger",
            message: "获取样本信息失败，请检查网络或刷新系统",
          });
        } else {
          this.rejectedSampleList = this.resolveSamples(
            response.map((item) => ({
              ...item.sample,
              ...item,
              // sample: null,
            }))
          );
          // console.log(this.rejectedSampleList, "response");
        }
      } catch (error) {
        console.log(error);
        this.$q.notify({
          type: "danger",
          message: "未知错误：" + error.toString(),
        });
      } finally {
        this.loadingSubmitedSampleList = false;
      }
    },

    async closeQualityEditor(ifClose) {
      // await this.loadSubmitedSampleList();
      if (ifClose) {
        this.showAnswerModal = false;
      }
    },

    async reflashList() {
      await this.loadSubmitedSampleList();
      await this.loadRejectedSampleList();
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";

#_tlqn_admin_quality {
  .q-table__container {
    box-shadow: none;
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
  }
}

.sticky-header-table {
  /* height: 310px; */
  border-radius: $generic-border-radius !important;

  .q-table__top,
  .q-table__bottom,
  thead tr:first-child th {
    background-color: $grey-2;
  }

  .q-table__middle.q-virtual-scroll.scroll {
    overflow: hidden;
    transition: all 0.1s ease;
    &:hover {
      overflow: auto;
    }
  }

  thead tr th {
    position: sticky;
    z-index: 1;
  }
  thead tr:first-child th {
    top: 0;
  }

  /* this is when the loading indicator appears */
  &.q-table--loading thead tr:last-child th {
    /* height of all previous header rows */
    top: 48px;
  }
}

.tlqn-ad-gmls-search-match {
  background-color: $primary;
  color: white;
  font-weight: bold;
}
</style>
